// extracted by mini-css-extract-plugin
export var brand = "_4b-9";
export var compact = "_4b-6";
export var extraSmall = "_4b-7";
export var icon = "_4b-0";
export var large = "_4b-4";
export var light = "_4b-1";
export var medium = "_4b-5";
export var outline = "_4b-b";
export var primaryDark = "_4b-a";
export var primaryLight = "_4b-8";
export var primaryModern = "_4b-c";
export var success = "_4b-2";
export var successSolid = "_4b-3";